export enum FieldLabels {
  LAST_NAME = 'Фамилия',
  FIRST_NAME = 'Имя',
  SECOND_NAME = 'Отчество',
  PHONE_NUMBER = 'Номер телефона',
  EMAIL = 'Электронная почта',
  POSTAL_CODE = 'Индекс',
  REGION = 'Регион/область',
  CITY = 'Город',
  STREET = 'Улица',
  HOUSE_NUMBER = 'Дом',
  CORPUS = 'Корпус',
  BUILDING = 'Строение',
  APARTMENT = 'Офис/кв',
  FLOOR = 'Этаж',
  COMMENT_ORDER = 'Комментарий к заказу',
  SEARCH = 'Поиск'
}
